import './CreditCardProcessRequeriments.scss';
import React, { Component, Fragment } from 'react';
import RequerimentText from './RequerimentText/RequerimentText';
// @ utilities
import { formatText } from 'core/i18n';

const DEFAULT_REQUERIMENTS_LIST = [
    { id: 1, requeriment: 'iban', size: 3 },
    { id: 2, requeriment: 'id', size: 3 },
    { id: 3, requeriment: 'mobile', size: 3 },
    { id: 4, requeriment: 'income', size: 3 },
];

export default class CreditCardProcessRequeriments extends Component {
    createRequerimentsColumns = requerimentLists => {
        return requerimentLists.map(object => {
            return (
                <div className={`requeriment col-sm-${object.size}`} key={object.id}>
                    <RequerimentText type={object.requeriment} />
                </div>
            );
        });
    };

    render() {
        return (
            <Fragment>
                <div className={`credit-card-hidden-anchor`} id="profileForm" />
                <div className="credit-card-process-requeriments">
                    <p className="process-title">{formatText('initial-creditCardProcessRequerimentsTitle')}</p>
                    <div className="row requirements">{this.createRequerimentsColumns(DEFAULT_REQUERIMENTS_LIST)}</div>
                </div>
            </Fragment>
        );
    }
}
